import { Dispatch } from 'react'
import { EMPTY, filter, fromEvent, map, merge, Observable, Subject } from 'rxjs'

import { localOrFallbackStorage } from '../../utils/storage'
import { isPractitionerFormsState, PractitionerFormsState } from './utils'

const key = 'practitioner_forms_state'

const parsePractitionerFormsState: (value: string | null) => PractitionerFormsState | undefined = (
  value,
) => {
  if (!value) {
    return undefined
  }
  try {
    const parsedState = JSON.parse(value)
    return isPractitionerFormsState(parsedState) ? parsedState : undefined
  } catch {
    return undefined
  }
}

export const readPractitionerFormsState: () => PractitionerFormsState | undefined = () =>
  parsePractitionerFormsState(localOrFallbackStorage.getItem(key))

const practitionerFormsStateInput = new Subject<PractitionerFormsState | undefined>()

export const practitionerFormsState$: Observable<PractitionerFormsState | undefined> = merge(
  practitionerFormsStateInput,
  typeof window !== 'undefined'
    ? fromEvent(window, 'storage').pipe(
        filter(
          (event): event is StorageEvent => event instanceof StorageEvent && event.key === key,
        ),
        map((event) => parsePractitionerFormsState(event.newValue)),
      )
    : EMPTY,
)

export const setPractitionerFormsState: Dispatch<PractitionerFormsState | undefined> = (value) => {
  if (value) {
    localOrFallbackStorage.setItem(key, JSON.stringify(value))
  } else {
    localOrFallbackStorage.removeItem(key)
  }
  practitionerFormsStateInput.next(value)
}
